import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';

export const useTrackAssetModalCommentPanelClose = () => {
  const { track } = useAnalyticsUtilities();

  const trackAssetModalCommentPanelClose = useCallback(() => {
    track(`Closed asset modal comment panel`);
  }, [track]);

  return { trackAssetModalCommentPanelClose };
};
